// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Xj4L5327s0e1LhZNBiWh_ postfix m-checkbox"};